import { IManagedUserAccessDataModel } from '../../data-models/managed-user-access.data-model';
import { IUserDataModel } from '../../data-models/user.data-model';
import { MaggieHttp } from '../MaggieHttp';

export async function getManagedUsersAccess(): Promise<IManagedUserAccessDataModel[]> {
  const { data } = await MaggieHttp.maggie.get<IManagedUserAccessDataModel[]>(
    '/user-company-access/limited-users/access'
  );

  return data;
}

export async function addManagedUserAccess(
  itemsToAdd: IManagedUserAccessDataModel[]
): Promise<IManagedUserAccessDataModel[]> {
  const { data } = await MaggieHttp.maggie.put<
    { items: IManagedUserAccessDataModel[] },
    IManagedUserAccessDataModel[]
  >('/user-company-access/limited-users/access', { items: itemsToAdd });

  return data;
}

export async function removeManagedUserAccess(
  itemsToRemove: IManagedUserAccessDataModel[]
): Promise<boolean> {
  await MaggieHttp.maggie.delete('/user-company-access/limited-users/access', {
    data: { items: itemsToRemove },
  });

  return true;
}

export async function getManagedUserList(): Promise<IUserDataModel[]> {
  const { data } = await MaggieHttp.maggie.get<IUserDataModel[]>(
    '/user-company-access/limited-users/user-list'
  );

  return data;
}
